import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-70789836"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "peilvsheding"
};
const _hoisted_2 = {
  key: 0,
  class: "panel-title"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_4 = {
  key: 1
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_6 = {
  class: "panel-body"
};
const _hoisted_7 = {
  class: "game-select"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("分类：");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("特殊用户设置");

const _hoisted_10 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("彩票：");

const _hoisted_12 = {
  style: {
    "margin-right": "6px"
  }
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("球号设置");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("单码");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("单组");

const _hoisted_16 = {
  class: "fast-set-row"
};
const _hoisted_17 = {
  class: "fast-set-item"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode("快速设置");

const _hoisted_19 = {
  class: "sub"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("保存设置");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_link = _resolveComponent("el-link");

  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_table = _resolveComponent("el-table");

  const _component_usersBatchSetLoss = _resolveComponent("usersBatchSetLoss");

  const _component_ballLossSet = _resolveComponent("ballLossSet");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass($data.parentMode != 'agency' ? 'panel' : '')
  }, [$data.parentMode != 'agency' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("h2", null, _toDisplayString($data.dialog.visible), 1), $data.dialog.visible == '球号设定' || $data.dialog.visible == '特殊用户' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    style: {
      "float": "right"
    },
    type: "warning",
    size: "small",
    onClick: _cache[0] || (_cache[0] = $event => $data.dialog.visible = '赔率设定')
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [$data.dialog.visible == '球号设定' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    style: {
      "float": "right"
    },
    type: "warning",
    size: "small",
    onClick: _cache[1] || (_cache[1] = $event => $data.dialog.visible = '赔率设定')
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  })) : _createCommentVNode("", true)])), _createElementVNode("div", _hoisted_6, [$data.dialog.visible == '赔率设定' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_pid,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.active_pid = $event),
    size: "small",
    onChange: $options.change_group
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_group, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), $data.parentMode != 'agency' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    style: {
      "margin-left": "20px",
      "float": "right"
    },
    size: "small",
    onClick: $options.get_users_set
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_gid,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.active_gid = $event),
    size: "small",
    onChange: $options.change_game
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])]), _createVNode(_component_el_table, {
    data: $data.set_data,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    append: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      size: "small",
      class: "fast-btn",
      onClick: $options.fast_set_col
    }, {
      default: _withCtx(() => [_hoisted_18]),
      _: 1
    }, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fast, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "fast-set-item",
        key: key
      }, [_createVNode(_component_el_input, {
        modelValue: $data.fast[key],
        "onUpdate:modelValue": $event => $data.fast[key] = $event,
        size: "small",
        placeholder: "快速设置",
        class: "fast-input",
        disabled: _ctx.$store.state.userinfo.group_id != 1 && key !== 'lower' && key !== 'rate'
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]);
    }), 128))])]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "下注类型",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, _toDisplayString(scope.row.name), 1), scope.row.name === '1-5球' || scope.row.name === '1-10球' || scope.row.name === '特码' || scope.row.name === '正码' || scope.row.name === '特码B' || scope.row.name === '正特' || scope.row.name === '正特一' || scope.row.name === '正特二' || scope.row.name === '正特三' || scope.row.name === '正特四' || scope.row.name === '正特五' || scope.row.name === '正特六' || scope.row.name === '连码三中二中二' || scope.row.name === '连码三全中' || scope.row.name === '连码二全中' || scope.row.name === '连码二中特中二' || scope.row.name === '连码特串' || scope.row.name === '四中一' || scope.row.name === '五不中' || scope.row.name === '六不中' || scope.row.name === '七不中' || scope.row.name === '八不中' || scope.row.name === '九不中' || scope.row.name === '十不中' || scope.row.name === '十一不中' || scope.row.name === '十二不中' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        plain: "",
        size: "small",
        type: "primary",
        onClick: $event => $options.ball_set(scope.row)
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
      _: 1
    }), _ctx.$store.state.userinfo.group_id == 2 || $data.show_type ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      prop: "type",
      label: "降赔类型",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_radio_group, {
        modelValue: scope.row.type,
        "onUpdate:modelValue": $event => scope.row.type = $event,
        onChange: $event => $options.change_type($event, scope.row)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1",
          size: "small"
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        }), scope.row.name.includes('连码') || scope.row.name.includes('连肖') || scope.row.name.includes('肖连') || scope.row.name.includes('尾连') || scope.row.name === '五不中' || scope.row.name === '六不中' || scope.row.name === '七不中' || scope.row.name === '八不中' || scope.row.name === '九不中' || scope.row.name === '十不中' || scope.row.name === '十一不中' || scope.row.name === '十二不中' || scope.row.name === '四中一' ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 0,
          label: "2",
          size: "small"
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "high_rate",
      label: "赔率上限",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "play_rate",
      label: "开盘赔率（A盘）",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.play_rate,
        "onUpdate:modelValue": $event => scope.row.play_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "low_rate",
      label: "A盘下限",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.low_rate,
        "onUpdate:modelValue": $event => scope.row.low_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "b_rate",
      label: "B盘赔率",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.b_rate,
        "onUpdate:modelValue": $event => scope.row.b_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "c_rate",
      label: "C盘赔率",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.c_rate,
        "onUpdate:modelValue": $event => scope.row.c_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "lower",
      label: "自动降赔率额度",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.lower,
        "onUpdate:modelValue": $event => scope.row.lower = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "rate",
      label: "每次降赔率",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.rate,
        "onUpdate:modelValue": $event => scope.row.rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
    size: "small",
    type: "info",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_hoisted_20]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_set
  }, {
    default: _withCtx(() => [_hoisted_21]),
    _: 1
  }, 8, ["onClick"])])], 64)) : _createCommentVNode("", true), $data.dialog.visible == '特殊用户' ? (_openBlock(), _createBlock(_component_usersBatchSetLoss, {
    key: 1,
    ref: "usersBatchSetLoss",
    game_list: $data.game_list
  }, null, 8, ["game_list"])) : _createCommentVNode("", true), $data.dialog.visible == '球号设定' ? (_openBlock(), _createBlock(_component_ballLossSet, {
    key: 2,
    ref: "ballLossSet"
  }, null, 512)) : _createCommentVNode("", true)])], 2)]);
}